import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { WakeUpCall } from './components/WakeUpCall';
import { ProductShowcase } from './components/ProductShowcase';
import { ValueStack } from './components/ValueStack';
import { QualityAssurance } from './components/QualityAssurance';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-green-500/30" data-id="element-0" data-mp="2riko97zkgfcl">
      <AnnouncementBar data-id="element-1" data-mp="2mjpwhgjmfggc" />
      <main data-id="element-2" data-mp="31agmqk5ke7hc">
        <Hero data-id="element-3" data-mp="31b8ko1mmwhas" />
        <WakeUpCall data-id="element-4" data-mp="31bs1tg4gn1nr" />
        <ProductShowcase data-id="element-5" data-mp="31c9tdzg6grpc" />
        <ValueStack data-id="element-6" data-mp="31cjo20c63n1d" />
        <QualityAssurance data-id="element-7" data-mp="2wka0gqyiyz29" />
        <FAQ data-id="element-8" data-mp="2wiywor52xrb5" />
        <FinalCTA data-id="element-9" data-mp="2wiff5bjcd4xn" />
      </main>
    </div>;
}